module.exports = __webpack_public_path__ + "img/prize_4_hasud.921065f5.jpg";